import { createFileRoute } from '@tanstack/react-router'

import { GlobalRoleType } from '@beaded/models'

import { requireGlobalRole } from 'lib/routeGuards'

import CablePricing from 'pages/CablePricing'

export const Route = createFileRoute('/_auth/_global/cable-pricing')({
  beforeLoad: requireGlobalRole(GlobalRoleType.SALES_ADMIN),
  component: CablePricing,
})
